<template>
	<div class="post-tooltip">
		<ul class="post-tooltip__icons">
			<li
				@click="shareFacebook"
			>
				<helio-icon
					class="post-tooltip__icon post-tooltip__icon--facebook"
					token="facebook-f"
					weight="brand"
				/>
			</li>
			<li
				@click="shareTwitter"
			>
				<helio-icon
					class="post-tooltip__icon post-tooltip__icon--twitter"
					token="twitter"
					weight="brand"
				/>
			</li>
			<li>
				<helio-icon
					class="post-tooltip__icon post-tooltip__icon--copy"
					token="copy"
					weight="bold"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import Icon from '../../icon/Icon.vue';

export default {
	components: {
		'helio-icon': Icon,
	},
	props: {
		text: {
			type: String,
			required: true,
			default: null,
		},
	},
	methods: {
		shareTwitter() {
			const url = document.URL;
			window.open(`http://twitter.com/share?text="${this.text}"&url=${url}`, 'twitter-popup', 'height=350,width=600');
		},
		shareFacebook() {
			const url = document.URL;
			window.open(`https://www.facebook.com/sharer.php?u=${url}&quote=${this.text}`, 'facebook-popup', 'height=350,width=600');
		},
	},
};
</script>

<style lang="scss" src="./post-tooltip.scss" />
